// statusCode values the consumer backend returns for the /auth/*_password endpoints
// (ConsumerConstants.Codes.RESP_CODE__*). The UI branches on these, never on message text,
// because the backend translates messages into the shopper's language.
export const AUTH_CODES = {
  NO_ACCOUNT: 461,
  PASSWORD_NOT_SET: 462,
  WRONG_PASSWORD: 463,
  TOO_MANY_ATTEMPTS: 464,
  ACCOUNT_EXISTS: 465,
  WRONG_CODE: 466,
  INVALID_PASSWORD: 467,
};

export const MIN_PASSWORD = 8;
export const MAX_PASSWORD = 64;

export const authErrorCode = (err) => err?.response?.data?.statusCode;
export const authErrorMessage = (err) => err?.response?.data?.message;

export const isPasswordValid = (pw) =>
  !!pw && pw.length >= MIN_PASSWORD && pw.length <= MAX_PASSWORD;

// Indian mobile numbers start with 6-9. Only checked for +91: every other country keeps the
// length-only check in Utils/countries.isCompleteNumber. A number that cannot exist could never
// receive the WhatsApp code, so its owner could never reset the password.
export const isPlausibleMobile = (dial, mobile) =>
  dial !== "91" || /^[6-9]/.test(mobile || "");
